export default __webpack_public_path__ + "static/media/a008-4.b28e95de.svg";